import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import {
  JeevesOrderActionConfigService,
  JeevesOrderDetailsComponent,
  JeevesOrderDetailsConfigService
} from 'gung-standard-jeeves';
import { OrderService, AuthService, BackendInterceptor, ProductService, BaseViewConfigService, ProductAssortmentParentService } from 'gung-standard';
import { CommonModalService, DateUtilService } from 'gung-common';
import { environment } from './../../../environments/environment';

@Component({
    selector: 'tylo-tylo-order-details',
    templateUrl: './tylo-order-details.component.html',
    styleUrls: ['./tylo-order-details.component.css'],
    standalone: false
})
export class TyloOrderDetailsComponent extends JeevesOrderDetailsComponent {
  currentLang = this.translateService.currentLang || 'se';
  isTylo = environment.projectName === 'tylo';

}
